
// ! rename the function to align with the widget name

import { clamp } from "lodash";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)

export const customFooter = () => {
    const el = document.querySelector('.curious-custom-footer');
    if (!el) return;

    // ------------------------------------------------------------
    
    const svgTag = el.querySelector('#footer_graphic');
    const layers = svgTag.querySelectorAll('.layer');
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "bottom bottom",
            scrub: true,
        },
    });

    layers.forEach(layer => {
        const speed = parseFloat(layer.dataset.speed);
        const movement = (layer.getBoundingClientRect().height * speed)
        
        tl.fromTo(layer, {
            y: movement, 
            ease: "none"
        }, {
            y: 0,
        }, 0)
    });

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

